module.exports = __webpack_public_path__ + "static/media/redux-original.b7dc3b99.svg";